import React from 'react';
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import Sidebar from '../components/Sidebar/Sidebar';

const Auth = ({ children }) => {
  
  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="d-flex flex-grow-1 w-100" style={{ overflow: 'hidden' }}>
        

        <div
          className="bg-light p-3 d-none d-md-block"
          style={{
            width: '250px',
            flexShrink: 0,
            overflowY: 'auto',
            height: '100%',
            borderRight: '1px solid #ddd'
          }}
        >
            <Sidebar />
          </div>

        <main className="flex-grow-1 p-3 overflow-auto" style={{ minWidth: 0 }}>
          <Header />
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-12 col-md-11 col-lg-10 mb-4 mt-4">
                {children}
              </div>
            </div>
          </div>
        </main>
      </div>

      <Footer />
    </div>
  );
  };
  
  export default Auth;